<template>
    <div class="login">
        <el-row>
            <el-col :span="16">
                <div  class="show-img-box">
                    <img src="http://foo.ibianma.com/jingying/word/2023/01/12/b7fcf0fc867ba2e23522ce887a86d71a.png" alt="" style="width:60%">
                </div>

            </el-col>
            <el-col :span="8" >
                <div class="m-auth-box">
                    <el-form ref="form" :model="form" :rules="rules" label-width="" class="auth-form">

                        <h1 class="title">
                                登录
                            </h1>
                        <el-form-item label="" prop="mobile">
                            <el-input v-model="form.mobile"  maxlength="64" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="sendcode">
                            <el-input v-model="form.sendcode" type="password" id="password" maxlength="64" placeholder="请输入短信验证码" class="" style="">
                                <template slot="append">
                                    <el-button type="primary" @click="getCode" >{{codeContent}}</el-button>
                                </template>
                            </el-input>
                        </el-form-item>

                        <el-form-item label="">
                            <el-button type="primary" style="width: 100%;" @click="login">登录</el-button>
                        </el-form-item>
                    
                    </el-form>

                </div>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import {fetchFocus, fetchList, articleList} from '../api'
    import { loginCode} from '@/api'
    import store from '@/store'

    export default {
        name: 'Login',
        props: ['cate', 'words'],
        data() {
            return {
                codeContent:"获取验证码",
                sendType:true,
                form:{
                    login_type: 'YZM',
                    area_code: 86,
                    mobile: '',
                    sendcode: '',
                    role:'1'
                },
                rules: { // 验证条件
                    sendcode: [
                        { required: true, message: '请输入验证码', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入正确的电话', trigger: 'change,blur' }
                    ]
                }

            }
        },
        computed: {
            loginType() {
                return this.$store.state.user.loginType
            }
        },
        methods: {
            getCode()
            {

                var that = this
                if(this.sendType == true)
                {
                    loginCode(this.form).then(response => {
                        
                    })

                    this.sendType = false
                    var i = 59
                    var codeTimeInterVal = setInterval(function(){
                        if(i > 0){
                            var text = i +"秒"
                            that.codeContent = text
                        }else{
                            that.sendType = true
                            that.codeContent = "重新发送"
                            clearInterval(codeTimeInterVal);
                            return;
                        }
                        i--;
                    }, 1000);
                }
                return;
            },
            closeBtn()
            {
                store.dispatch('user/setLoginType', false);
            },
            login()
            {

                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        store.dispatch('user/login', this.form).then(response => {
                            this.$router.push({path:'/myclass'})
                     
                        });
                    }
                })
                
            }

        },
        watch: {
            loginType: {
                immediate: true,
                handler: (n, o) => {
                    let htmlBodyElement = document.querySelector('body');
                    htmlBodyElement.style.overflowY = n ? 'hidden' : 'auto';
                }
            }
        }
    
    }
</script>
<style scoped lang="less">

    .show-img-box{
        padding-top:100px;
        text-align: center;
        padding-bottom:100px;
    }
    .login{
   
            background: #18A5FF;
    }
    .m-auth-box{
        padding-top:100px;
    }

        .auth-modal-box {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,.3);
        z-index: 1001;
    }
    
    .auth-modal-box .btn {
        width: 100%;
        height: 46px;
        color: #fff;
        background-color: #007fff;
        border-radius: 2px;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;
    }
    .auth-form {
        position: relative;
        padding: 24px;
        width: 350px;
        max-width: 100%;
        font-size: 14px;
        background-color: #fff;
        border-radius: 2px;
        box-sizing: border-box;
    }

        .panfish .normal {
        position: absolute;
        top: 0;
        left: 50%;
        width: 10rem;
        -webkit-transform: translate(-50%,-83%);
        transform: translate(-50%,-83%);
        z-index: 1;
    }
    
    .panfish .greeting {
        position: absolute;
        top: 0;
        left: 50%;
        width: 10rem;
        -webkit-transform: translate(-50%,-75.8%);
        transform: translate(-50%,-75.8%);
        z-index: 1;
    }
    
    .panfish .blindfold {
        position: absolute;
        top: 0;
        left: 50%;
        width: 8.6rem;
        -webkit-transform: translate(-50%,-75%);
        transform: translate(-50%,-75%);
        z-index: 1;
    }
    
    .close-btn {
        float: right;
        cursor: pointer;
        opacity: .4;
    }

    
    .title {
        font-size: 1.1rem;
        margin: 0 0 1rem;
    }
    
    /* .btn {
        width: 100%;
        height: 3.334rem;
        color: #fff;
        background-color: #007fff;
        border-radius: 2px;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;
    } */
    
    .prompt-box {
        margin: 1rem 0 0;
        color: #8b9196;
    }
    
    .oauth-box .oauth-bg, .oauth-box .oauth{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .oauth-box .oauth {
        -ms-flex-pack: distribute;
        justify-content: space-around;
        margin-top: 15px;
    }
    .oauth-box {
        margin-top: 1.2rem;
        line-height: 1.9rem;
        color: #8b9196;
    }
    .oauth-box .oauth {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    
    .oauth-box .oauth-bg {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background-color: #f4f8fb;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
    
    .oauth-box .oauth-btn {
        height: 1.9rem;
        vertical-align: bottom;
        cursor: pointer;
    }
    .oauth-box img {
        border-style: none;
    }
    
    .input-box {
        position: relative;
        margin-bottom: 15px;
    }
    .input {
        padding: 10px;
        width: 272px;
        border: 1px solid #e9e9e9;
        border-radius: 2px;
        outline: none;
        box-sizing: border-box;
    }
    .min-width {
        min-width: 1200px;
    }
    #nav .menu-item {
        float: left;
    }
    .nav-right {
        float: right;
    }
    .nav-left {
        float: left;
    }
    #searchform {
        padding-top:8px;
    }
    .user-info {
        display: none;
        height:50px;
        line-height: 50px;
        padding-left:10px;
        cursor: pointer;
    }

  
    /******/
    @media (max-width: 800px) {
        .top-feature {
            display: none;
        }

        .site-main {
            padding-top: 40px;
        }

        .site-content {
            .notify {
                margin: 30px 0 0 0;
            }

            .search-result {
                margin-bottom: 20px;
                font-size: 16px;
            }
        }
    }

    /******/
</style>
